import { NgModule } from '@angular/core';
import {
  AuthModule,
  BaseOccModule,
  ConfigModule,
  ProductModule,
  ProductOccModule,
  SiteContextModule,
  UserModule,
  UserOccModule,
} from '@spartacus/core';
import 'app/core/augmentation/slb.models';
import { SpartacusConfigurationModule } from 'app/spartacus/spartacus-configuration.module';

@NgModule({
  imports: [
    ConfigModule.forRoot(),
    BaseOccModule.forRoot(),
    SiteContextModule.forRoot(),
    AuthModule.forRoot(),
    ProductModule.forRoot(),
    ProductOccModule,
    UserModule,
    UserOccModule,
    SpartacusConfigurationModule,
  ],
})
export class SpartacusProvidersModule {}
